import { useCallback } from 'react';
import { isNil } from 'es-toolkit';
import { graphql } from 'src/gql';
import { useActiveHouseholdId } from 'src/hooks/use-active-household-id';

import { useQueryWithErrorLogging } from '@savvy/graphql-hooks/useQueryWithErrorLogging';

import { openClientTasks } from '../common/tasks';

export const CLIENT_PORTAL_OPEN_TASKS_QUERY = graphql(/* GraphQL */ `
  query ClientPortalOpenTasks($householdId: ID) {
    tasks(household: true, householdId: $householdId) {
      id
      type
      status
    }
  }
`);

export type ClientPortalOpenTasksState = {
  readonly openCount: number;
  readonly loading: boolean;
  readonly failed: boolean;
  readonly retry: () => void;
};

export function useClientPortalOpenTasks(): ClientPortalOpenTasksState {
  const { activeHouseholdId, canQuery } = useActiveHouseholdId();

  const { data, loading, error, refetch } = useQueryWithErrorLogging(CLIENT_PORTAL_OPEN_TASKS_QUERY, {
    variables: { householdId: activeHouseholdId ?? undefined },
    skip: !canQuery,
  });

  const retry = useCallback(() => {
    if (canQuery) {
      void refetch();
    }
  }, [canQuery, refetch]);

  const failed = !isNil(error);
  const openCount = failed ? 0 : openClientTasks(data?.tasks).length;

  return {
    openCount,
    loading: loading || !canQuery,
    failed,
    retry,
  };
}
